module.exports = __webpack_public_path__ + "static/img/image.5a05138.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sm/psychology/image.jpg
// module id = bhPe
// module chunks = 0